import { defineStore } from "pinia";

export const useMenuStore = defineStore("menuAccessibles", {
  state: () => ({
    data: null as any,
  }),
  actions: {
    getData(): any[] {
      const menu = localStorage.getItem("menuAccessibles");
      if (menu) return JSON.parse(menu);
      return [];
    },
    setData(data: any[]) {
      localStorage.setItem("menuAccessibles", JSON.stringify(data));
    },
    clear() {
      localStorage.removeItem("menuAccessibles");
    },
  },
});
